import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    box: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
